if (!customElements.get('wls-countdown')) {
  class WLSCountdown extends HTMLElement {
    constructor() {
      super();

      this.interval = null;
      this.targetDate = null;

      this.daysEl = null;
      this.hoursEl = null;
      this.minutesEl = null;
      this.secondsEl = null;
    }

    connectedCallback() {
      this.initialize();
    }

    initialize() {
      const dateStr = this.dataset.countdownDate;
      const timeStr = this.dataset.countdownTime || '00:00';

      if (!dateStr) return;

      const [month, day, year] = dateStr.split('-').map(Number);
      const [hours = 0, minutes = 0] = timeStr.split(':').map(Number);

      this.targetDate = new Date(
        year,
        month - 1,
        day,
        hours,
        minutes,
        0
      );

      this.daysEl = this.querySelector('.wls-countdown-days');
      this.hoursEl = this.querySelector('.wls-countdown-hours');
      this.minutesEl = this.querySelector('.wls-countdown-minutes');
      this.secondsEl = this.querySelector('.wls-countdown-seconds');

      if (
        !this.daysEl ||
        !this.hoursEl ||
        !this.minutesEl ||
        !this.secondsEl
      ) {
        return;
      }

      this.updateCountdown();

      this.interval = setInterval(() => {
        const shouldContinue = this.updateCountdown();

        if (!shouldContinue) {
          this.clearTimer();
        }
      }, 1000);
    }

    updateCountdown() {
      const difference = this.targetDate - new Date();

      if (difference <= 0) {
        this.updateDisplay(0, 0, 0, 0);
        this.classList.add('wls-countdown-expired');

        return false;
      }

      const days = Math.floor(
        difference / (1000 * 60 * 60 * 24)
      );

      const hours = Math.floor(
        (difference % (1000 * 60 * 60 * 24)) /
        (1000 * 60 * 60)
      );

      const minutes = Math.floor(
        (difference % (1000 * 60 * 60)) /
        (1000 * 60)
      );

      const seconds = Math.floor(
        (difference % (1000 * 60)) / 1000
      );

      this.updateDisplay(days, hours, minutes, seconds);

      return true;
    }

    updateDisplay(days, hours, minutes, seconds) {
      this.daysEl.textContent = String(days).padStart(2, '0');
      this.hoursEl.textContent = String(hours).padStart(2, '0');
      this.minutesEl.textContent = String(minutes).padStart(2, '0');
      this.secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    clearTimer() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }

    disconnectedCallback() {
      this.clearTimer();
    }
  }

  customElements.define('wls-countdown', WLSCountdown);
}

if (!customElements.get('wls-announcement-bar')) {
  class WLSAnnouncementBar extends HTMLElement {
    static instances = new Set();

    static updateAllHeights() {
      let totalHeight = 0;

      [...WLSAnnouncementBar.instances].forEach(
        (instance, index) => {
          const height = instance.offsetHeight;

          document.documentElement.style.setProperty(
            `--announcement-bar-height-${index}`,
            `${height}px`
          );

          totalHeight += height;
        }
      );

      document.documentElement.style.setProperty(
        '--announcement-bar-height',
        `${totalHeight}px`
      );
    }

    constructor() {
      super();

      this.resizeObserver = null;
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      WLSAnnouncementBar.instances.add(this);

      WLSAnnouncementBar.updateAllHeights();

      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(() => {
          WLSAnnouncementBar.updateAllHeights();
        });

        this.resizeObserver.observe(this);
      } else {
        window.addEventListener('resize', this.handleResize);
      }
    }

    handleResize() {
      WLSAnnouncementBar.updateAllHeights();
    }

    disconnectedCallback() {
      WLSAnnouncementBar.instances.delete(this);

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
      window.removeEventListener('resize', this.handleResize);

      WLSAnnouncementBar.updateAllHeights();
    }
  }

  customElements.define(
    'wls-announcement-bar',
    WLSAnnouncementBar
  );
}